module.exports = __webpack_public_path__ + "static/Lodging_Sheraton-16b4c9fe50c22eb5ecbc57512f31f42d.jpg";